<template>
  <PageLoader :loading="loading">
    <EventPage v-if="event" :event="event" />
    <ProductPage v-else-if="product" :product="product" />
    <ServicePage
      v-else-if="service"
      :provider="service.provider"
      :service="service.service"
      :show-menu="false"
      :show-return="false"
    />
  </PageLoader>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { usePlatformApi } from "@/services/platform-api";
import PageLoader from "@/components/pages/PageLoader";
import { salesApi } from "~/services/sales-api";

// lazy load page components
const EventPage = defineAsyncComponent(
  () => import("@/components/pages/event")
);
const ProductPage = defineAsyncComponent(
  () => import("@/components/pages/product")
);
const ServicePage = defineAsyncComponent(
  () => import("@/components/pages/service")
);

export default defineComponent({
  components: { PageLoader, ProductPage, EventPage, ServicePage },
  setup() {
    definePageMeta({
      layout: "anonymous",
      disableHeaderStick: true,
      headerDark: true,
    });
    const route = useRoute();
    const api = usePlatformApi();
    const sales = salesApi();
    const pkApplied = ref(false);

    const item = observeAsync(api.listing.find);

    item.handle(String(route.params.id || ""));

    item.onResult(() => {
      if (item.result.value?.pk) {
        sales.client.setPublishableKey(item.result.value.pk.token);
        pkApplied.value = true;
      }
    });

    const event = computed(() => {
      if (pkApplied.value && item.result.value?.object?.object == "event") {
        return item.result.value.object;
      }
    });

    const product = computed(() => {
      if (pkApplied.value && item.result.value?.object?.object == "product") {
        return item.result.value.object;
      }
    });

    const service = computed(() => {
      if (
        pkApplied.value &&
        item.result.value?.object?.object == "service" &&
        item.result.value.object.provider
      ) {
        return {
          provider: item.result.value.object.provider,
          service: item.result.value.object,
        };
      }
    });

    // reset publishable key to marketplace's default before leaving page
    // onBeforeRouteUpdate(sales.resetPublishableKey);

    return {
      event,
      product,
      service,
      pkApplied,
      loading: item.loading,
    };
  },
});
</script>
